import campaignDialogComponent from './campaign-dialog.component';


export default angular
  .module('fizyweb.paycell.campaignDialog', [])
  .component('campaignDialog', campaignDialogComponent).name;



// WEBPACK FOOTER //
// src/app/components/campaign-dialog/campaign-dialog.module.ts